module.exports = __webpack_public_path__ + "static/media/jg.44242d38.png";